import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany,loginOrg } from '@/utils/LoginContext';

export async function query(payload) {
  return request(`/iwms-wms/wms/container/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryByStateAndPosition(payload) {
  return request(`/iwms-wms/wms/container/queryByStateAndPosition`, {
    method: 'POST',
    body: payload,
  });
}

export async function queryIdleAndThisPostionUseing(payload) {
  return request(`/iwms-wms/wms/container/queryIdleAndThisPostionUseing`, {
    method: 'POST',
    body: payload,
  });
}

export async function save(payload) {
  return request(`/iwms-wms/wms/container`, {
    method: 'POST',
    body: payload,
  },true);
}

export async function get(payload) {
  const companyUuid = loginCompany().uuid;
  const dcUuid = loginOrg().uuid;
  return request(`/iwms-wms/wms/container/${payload.barcode}?companyUuid=${companyUuid}&dcUuid=${dcUuid}`);
}

export async function getLastBarcode(payload) {
  const dcUuid = loginOrg().uuid;
  return request(`/iwms-wms/wms/container/last/${payload.barcode}?dcUuid=${dcUuid}&containerTypeUuid=${payload.typeUuid}&num=${payload.num}&numberType=${payload.numberType}`);
}

export async function getNextValue(payload) {
  const dcUuid = loginOrg().uuid;
  return request(`/iwms-wms/wms/container/next/barcode?dcUuid=${dcUuid}&containerTypeUuid=${payload.typeUuid}`);
}

export async function getContainerArts(payload) {
  const companyUuid = loginCompany().uuid;
  const dcUuid = loginOrg().uuid;
  return request(`/iwms-wms/wms/container/getContainerArts?containerBarcode=${payload.barcode}&companyUuid=${companyUuid}&dcUuid=${dcUuid}`);
}

export async function rollback(payload) {
  return request(`/iwms-wms/wms/container/rollback`, {
    method: 'POST',
    body: payload,
  });
}

export async function fullfilContainer(payload) {
  return request(`/iwms-wms/wms/container/fullfilContainer`, {
    method: 'POST',
    body: payload,
  });
}

export async function take(payload) {
  return request(`/iwms-wms/wms/container/take`, {
    method: 'POST',
    body: payload,
  });
}

// web端增加容器'满容'功能
export async function full(payload) {
  const companyUuid = loginCompany().uuid;
  const dcUuid = loginOrg().uuid;
  return request(`/iwms-wms/wms/full/${payload.containerBarcode}/full?&companyUuid=${companyUuid}&dcUuid=${dcUuid}&parentContainerBarcode=${payload.parentContainerBarcode ? payload.parentContainerBarcode : ''}`, {
    method: 'POST',
  });
}

// 满容校验
export async function verifyFull(payload) {
  const companyUuid = loginCompany().uuid;
  const dcUuid = loginOrg().uuid;
  return request(`/iwms-wms/wms/full/${payload.containerBarcode}/verify?&companyUuid=${companyUuid}&dcUuid=${dcUuid}`);
}

//获取附件信息
export async function getContainerAttach(payload){
  const companyUuid = loginCompany().uuid;
  const dcUuid = loginOrg().uuid;
  return request(`/iwms-wms/wms/container/${payload.containerBarcode}/getContainerAttach?&companyUuid=${companyUuid}&dcUuid=${dcUuid}`)
}
